import { Component, computed, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { rxResource } from '@angular/core/rxjs-interop';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalComponent, ModalButton } from '../../../common-components/modal/modal.component';
import { CardRun, CardRunCandidate, CardsAdminService } from '../../../services/admin/cards-admin.service';

@Component({
  selector: 'app-cards-runs-tab',
  imports: [TranslocoModule, ModalComponent, ReactiveFormsModule, DatePipe],
  templateUrl: './cards-runs-tab.component.html',
  styleUrl: './cards-runs-tab.component.scss'
})
export class CardsRunsTabComponent {
  runs = rxResource({ stream: () => this.cardsAdmin.getRuns$(), defaultValue: [] });
  sortedRuns = computed(() => [...this.runs.value()].sort((a, b) => b.id - a.id));

  showPublishModal = signal(false);
  showVoteModal = signal(false);
  selectedRun = signal<CardRun | null>(null);
  selectedCandidate = signal<CardRunCandidate | null>(null);
  voteDate = new FormControl<string>('', { nonNullable: true });

  publishModalButtons: ModalButton[] = [
    { type: 'secondary', text: this.transloco.translate('Cancel'), onClick: () => this.showPublishModal.set(false) },
    { type: 'primary', text: this.transloco.translate('cardsAdminPublish'), onClick: () => this.confirmPublish() }
  ];
  voteModalButtons: ModalButton[] = [
    { type: 'secondary', text: this.transloco.translate('Cancel'), onClick: () => this.showVoteModal.set(false) },
    { type: 'primary', text: this.transloco.translate('cardsAdminToVote'), onClick: () => this.confirmToVote() }
  ];

  constructor(
    private cardsAdmin: CardsAdminService,
    private transloco: TranslocoService,
    private snackBar: MatSnackBar
  ) {}

  statusClass(run: CardRun): string {
    if (run.status === 'closed' && run.candidates.some((c) => c.isWinner)) {
      return 'color-green';
    }
    if (run.status === 'failed') {
      return 'color-red';
    }
    return '';
  }

  openPublish(run: CardRun, candidate: CardRunCandidate): void {
    this.selectedRun.set(run);
    this.selectedCandidate.set(candidate);
    this.showPublishModal.set(true);
  }

  openToVote(run: CardRun): void {
    this.selectedRun.set(run);
    this.voteDate.setValue('');
    this.showVoteModal.set(true);
  }

  closePublish(): void {
    this.showPublishModal.set(false);
  }

  closeToVote(): void {
    this.showVoteModal.set(false);
  }

  confirmPublish(): void {
    const run = this.selectedRun();
    const candidate = this.selectedCandidate();
    if (!run || !candidate) {
      return;
    }
    this.cardsAdmin.publishRun$(run.id, candidate.id).subscribe(() => {
      this.showPublishModal.set(false);
      this.snackBar.open(this.transloco.translate('cardsAdminPublished'), '', { duration: 3000 });
      this.runs.reload();
    });
  }

  confirmToVote(): void {
    const run = this.selectedRun();
    if (!run || !this.voteDate.value) {
      return;
    }
    this.cardsAdmin.sendRunToVote$(run.id, this.voteDate.value).subscribe(() => {
      this.showVoteModal.set(false);
      this.snackBar.open(this.transloco.translate('cardsAdminStaged'), '', { duration: 3000 });
      this.runs.reload();
    });
  }
}
